module.exports = __webpack_public_path__ + "img/diamond.e69d770f.png";